export const Area = {
  CLIENT: null,
  PROJECT_MANAGER: 1,
  ROADS_SQUARES: 2,
  CONSTRUCTION: 3,
  ARCHITECTURE: 4,
  WATER_SEWER: 5,
  HEATING_VENTILATION: 6,
  ELECTRICITY_COMMUNICATION: 7,
  ACUSTICS: 8,
  ENERGY_MARK: 9,
  FIRE_SAFETY: 10,
  BIM: 11,
  AUTOMATICS: 12,
  GEODESY: 13,
  GEOLOGY: 14,
  DENDROLOGY: 15,
  ENV_IMPACT_ASSESSMENT: 16,
  DETAILED_PLANNING: 17,
  RADON: 18,
  NOISE: 19,
  EXPERTISE: 20,
  INTERNAL_ARCHITECTURE: 21,
  HEAT_SUPPLY: 22,
  SPRINKLER: 23,
  ENERGY_EFFICIENCY: 24,
  ENERGY_BOREHOLES: 25,
  SOLAR_PANEL_PROJECT: 26,
  CONSTRUCTION_CONSULTATION: 27,

  getName(id) {
    return Object.keys(Area).find(key => Area[key] === id);
  },

  getAllNamesTranslated() {
    return [
      {name: 'PJ', value: 1},
      {name: 'TE', value: 2},
      {name: 'KON', value: 3},
      {name: 'ARH', value: 4},
      {name: 'VK', value: 5},
      {name: 'KJV', value: 6},
      {name: 'EL', value: 7},
      {name: 'AK', value: 8},
      {name: 'EE', value: 9},
      {name: 'TO', value: 10},
      {name: 'BIM', value: 11},
      {name: 'EA', value: 12},
      {name: 'GEOD', value: 13},
      {name: 'GEOL', value: 14},
      {name: 'DENDRO', value: 15},
      {name: 'KMH', value: 16},
      {name: 'DP/MA', value: 17},
      {name: 'RA', value: 18},
      {name: 'MÜRA', value: 19},
      {name: 'EKSPERTIIS', value: 20},
      {name: 'SA', value: 21},
      {name: 'SOOJUSVAR', value: 22},
      {name: 'SPRINK', value: 23},
      {name: 'ENTÕH', value: 24},
      {name: 'PURA', value: 25},
      {name: 'PÄIK', value: 26},
      {name: 'EHKON', value: 27}
    ];
  }
}